// @ts-nocheck

import React, { useCallback, useMemo, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

import SpinePlayer from '../../../../components/SpinePlayer';
import { SpineAnimationIds } from '../../../../types/animations';
import { SoundIds } from '../../../../types/sounds';
import { type KLRound, KLRounds } from '../../types/round';

const Title = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  font-size: 2.5em;
  padding: 0.5em 0 0 0;
`;

const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Text = styled.div`
  width: 85%;
  margin-top: 1em;

  text-transform: uppercase;
  text-align: center;

  opacity: 0;
  ${({ $startAnimation }) =>
    $startAnimation &&
    css`
      animation: ${fadeInAnimation} 1.5s ease 2s;
    `}
  animation-fill-mode: forwards;
`;

const SpinePlayerWrapper = styled.div`
  width: 100%;
  margin-top: -5.5em;
  padding-bottom: 115%;
`;

type KLNotificationTorchProps = {
  roundId: KLRound;
};

const KLNotificationTorch = ({ roundId }: KLNotificationTorchProps) => {
  const [hasAnimationStarted, setHasAnimationStarted] = useState(false);

  const onStartAnimation = useCallback(() => {
    setHasAnimationStarted(true);
  }, []);

  const tribe = useMemo(() => {
    if (roundId === KLRounds.T_RED) {
      return { name: 'rouge', soundId: SoundIds.KL_ELIMINATION_T_RED };
    }
    if (roundId === KLRounds.T_WHITE) {
      return { name: 'blanche', soundId: SoundIds.KL_ELIMINATION_T_WHITE };
    }

    return {};
  }, [roundId]);

  return (
    <>
      <Title>Éliminé</Title>
      <Text $startAnimation={hasAnimationStarted}>
        La tribu {tribe.name} a décidé de vous éliminer, votre aventure s&apos;arrête là
      </Text>
      <SpinePlayerWrapper>
        <SpinePlayer
          animationId={SpineAnimationIds.KL_TORCH}
          soundId={tribe.soundId}
          scale={0.27}
          onStartAnimation={onStartAnimation}
        />
      </SpinePlayerWrapper>
    </>
  );
};

export default KLNotificationTorch;
